var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStartCreateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6884 5.35076H8.62255C6.59602 5.35076 5.58276 5.35076 4.80872 5.74515C4.12787 6.09206 3.57431 6.64562 3.2274 7.32648C2.83301 8.10051 2.83301 9.11377 2.83301 11.1403V21.272C2.83301 23.2985 2.83301 24.3118 3.2274 25.0858C3.57431 25.7667 4.12787 26.3203 4.80872 26.6672C5.58276 27.0616 6.59602 27.0616 8.62255 27.0616H18.7543C20.7808 27.0616 21.7941 27.0616 22.5681 26.6672C23.2489 26.3203 23.8025 25.7667 24.1494 25.0858C24.5438 24.3118 24.5438 23.2985 24.5438 21.272V16.2062M10.0699 19.8246H12.0897C12.6797 19.8246 12.9747 19.8246 13.2523 19.758C13.4985 19.6989 13.7338 19.6014 13.9496 19.4691C14.1931 19.32 14.4017 19.1114 14.8189 18.6941L26.353 7.15999C27.3523 6.16078 27.3523 4.54074 26.353 3.54152C25.3538 2.54231 23.7338 2.54231 22.7346 3.54152L11.2004 15.0757C10.7832 15.4929 10.5746 15.7015 10.4254 15.9449C10.2931 16.1608 10.1957 16.3961 10.1366 16.6422C10.0699 16.9199 10.0699 17.2149 10.0699 17.8049V19.8246Z",
    stroke: "#5A52C3",
    strokeWidth: 2.41231,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartCreateIcon);
export default __webpack_public_path__ + "static/media/start_createIcon.d8130caf569b48e50aee722b26d6a4f9.svg";
export { ForwardRef as ReactComponent };